export const PopUpMessage = {
    thank_you_initial_info:"Thank you for filling the Health Information!",
    choose_plan_message:'Please choose "Membership Plan" and make the payment to schedule an appointment.',
    plan_button_text:"Take Membership Plan",
    thank_you_niyama_msg:"Thank you for signing up to",
    take_assesment_msg:'You can do a free self-assessment by answering a few questions. Please select "Assessment" from the menu',
    current_health_info_msg:'Please share your current Health Information for our Care Team to understand better before scheduling an appointment.',
    select_health_info_text:'Please select "Health Information" from the menu, to enter the mandatory fields.',
    thank_you_msg:"Thank you for choosing HealthEdge!",
    consultation_details_msg:" Please find your consultation details.",
    thank_you_apointment_req_msg:"Thank you for requesting appointment!",
    join_consultation_eva_msg:"Doctor is allocated kindly join the consultation at ",
    join_consultation_other_msg:"Appointment is confirmed, kindly join the consultation at ",
    join_consultation__msg_1:"Your appointment is confirmed with",
    join_consultation__msg_2:" Please remember to join the consultation at",
    please_wait_msg:"Please wait for our Care Admin to confirm the same.",
    my_consultations: "My Consultations",
    my_consultations_subtitle: "Pending appointments for today",
    my_patient: "My Patients",
    my_patient_subtitle: "Missed prescriptions & case notes for this month",
    hi: "Hi",
    THANK_YOU_FOR_CHOOSING: "Thank you for choosing",
    PLEASE_BOOK_APPOINTMENT: "Please book an appointment with our specialized Doctors for a detailed",
    SMALL_CONSULTATION: "consultation",
    SMALL_EVALUATION: "evaluation",
    SESSION: "session",
    PLEASE_UPGRADE_RENEW: "Please upgrade or renew your plan to Schedule Appointment.",
    COMPLETED_EVALUATION: "You have completed your evaluation plan.",
    CHOOSE_SUBSCRIPTION_PLAN: "Please choose your suggested membership plan.",
    RENEW_YOUR_PLAN: "Please renew your plan to enable Scheduling appointment.",
    YOUR_DASHBOARD: "Your",
    HAS_EXPIRED: "has expired.",


}

export const CONSTANTS ={
// Patient side constants
    SELF_ASSESSMENT: "Self Assessment",
    ASSESSMENT_TEXT:"Along with your regular reflection, assessing your current risk for common conditions can be an important part of caring for your mental health.",
    TAKE_ASSESSMENT: "Take Assessment",
    VIEW_DETAILS: "View Details",
    DEPRESSION: "Depression",
    ANXIETY: "Anxiety",
    STRESS: "Stress",
    DEPRESSION_ANXIETY: "Depression / Anxiety",
    SELF_ASSESSMENT_SENIOR_ADULT: "Self assessment for senior adult",
    SELECT_ASSESSMENT_LANDING_DESCRIPTION_1: "You can take these assessments every 15 days, from your last assessed date.",
    LAST_ASSESSED_ON: "Last assessed on",
    TAKE_ASSESSMENT_FROM:"Next assessment on",
    BACK_TO_PREVIOUS_PAGE: "< Back To Previous Page",
    QUESTION: "Question",
    HEALTH_INFORMATION: "Health Information",
    MEDICAL_DOCUMENT: "Medical Document",
    YOUR_MEDICAL_HISTORY: "Your medical history will help us provide a personalized holistic multi disciplinary care.",
    BASIC_INFORMATION: "Basic Information",
    MY_APPOINTMENTS: "My Appointments",
    VIDEO_CONSULTATION: "Video Consultation",
    PHI_CARD_DESCRIPTION: "Click on Health Information to enter your health related data.",
    COMPLETED: "% Completed",
    YOU_HAVE_COMPLETED: "You have completed",
    ASSESSMENT_S: "assessment(s)",
    ASSESSMENTS: "Assessments",
    NIYAMA_CARE_DESCRIPTION_1: "Get yourself evaluated by our Clinician",
    NIYAMA_CARE_DESCRIPTION_2: "Please upgrade or extend your plan to schedule an appointment",
    NIYAMA_CARE: "HealthEdge Care",
    VIEW_PLAN: "View Plan",
    NIYAMA_CARE_DESCRIPTION_3_PART2: " | Valid upto",
    NIYAMA_CARE_DESCRIPTION_3_PART1: "You are subscribed to",
    TAKE_SUBSCRIPTION_PLAN: "Take Membership Plan",
    YOUR: "Your",
    NOT_SUBSCRIBED_CENTER_TEXT_1: "has expired.",
    NOT_SUBSCRIBED_CENTER_TEXT_2: "You have not subscribed yet!",
    NOT_SUBSCRIBED_CENTER_TEXT_3: "Only one appointment can be scheduled in accordance with your current membership plan.",
    NO_APPONITMENTS: "No appointments booked yet!",
    COMMON_WRAPPER_CARD_CONTENT_APPOINTMENT: "Please subscribe to a membership plan and book appointments.",
    LAST_CONSULTATION: "Last consultation done with ",
    NO_CONSULTATION: "No consultations done yet!",
    TASKS_FOR_YOU: "TASKS FOR YOU",
    COMPLETE_SELF_ASSESSMENT: "Complete Self Assessment",
    FILL_UP_HEALTH_INFORMATION: "Fill up Health Information",
    GET_THE_RIGHT_PLAN: "Get the right plan",
    BASIC_HEALTH_INFORMATION: "(Basic Health Information is not yet filled.)",
    SELF_ASSESSMENT_NOT_TAKEN: "(Self Assessment is not yet taken.)",
    HAVENT_SUBSCRIBED: "(You haven't subscribed to any plan yet.)",
    BOOK_YOUR_APPOINTMENT: "Book your Appointment",
    JOIN_NOW: "Join now",
    CLICK_JOIN_TO_START: "Click 'join' to start the consultation with",
    APPOINTMENT_DETAILS: "Appointment Details",
    TIME: "Time",
    SUBSCRIPTION_PLAN: "Membership Plan",
    PREVIEWING: "Previewing...",
    PREVIEW_VIDEO: "Preview Video",
    SAY_SOMETHING: "Say Something",
    CHECK_AUDIO: "Check Audio",
    CANCEL: "Cancel",
    TEST_CONNECTION_JOIN: "Test Connection and Join",
    NO_ASSESSMENT_DONE: "No assessments done yet!",
    PLEASE_TAKE_SELF_ASSESSMENT: "Please take self-assessment to unlock this section.",
    TAKE_EVALUATION_PLAN:"Take Evaluation Plan",
    BOOK_APPOINTMENT_CARD_DESCRIPTION:"Your appointment is confirmed & scheduled with ",
    BOOK_APPOINTMENT_CARD_DESCRIPTION_1: "Your appointment will be confirmed soon.",
    APPOINTMENTS: "Appointments",
    CONSULTATION: "Consultations",
    SELF_ASSESSMENT_ADOLESCENT: "Self Assessment for Adolescents",
    NO_SELF_ASSESSMENT: "No Self-Assessment option is enabled for your profile.",
    SCHEDULE_TEXT:"Select your preferred time slot and doctor to book appointment",
    // SCHEDULE_APPOINTMENT: "Schedule Appointment",
    SCHEDULE_APPOINTMENT: "Appointment",
    BOOK_NOW: "Book Now",
    UPCOMING: "Upcoming",
    PAST: "Past",
    EVALUATION_REPORT: "Psychological Feedback Report",
    PRESCRIPTION: "Prescription",
    ZERO_ENCOUNTER: "Zero Encounter",
    APPOINTMENT_STATUS:"Appointment Status",
    MODE: "Mode:",
    SEARCH_BY_DOCTOR: "Search by doctor...",
    SELECT_YOUR_DATE: "SELECT YOUR DATE",
    SELECT_YOUR_TIME_SLOT: "SELECT YOUR TIME",
    SELECTED_DATE: "Selected Date",
    SUBSCRIPTION_TITLE: "Choose a recommended plan to begin your treatment journey with",
    CONFIRMATION_TEXT: "You already have an active membership plan, by continuing with the new plan, you can't enjoy the benefits of the old plan. Would you like to proceed?",
    APPOINTMENT_CENTER_TEXT: "You can schedule a call after a care team is assigned to you. You shall receive an email/mobile notification once the care team is assigned.",
    SUBSCRIPTION_EVAL_MESSAGE: "we do a detailed evaluation adhering to the international standards of assessment. This is to help us arrive at an accurate diagnosis of your problem and suggest an appropriate treatment plan for you to effectively manage the condition.",
    EXPIRED: "Expired",
    ACTIVE: "Active",
    USE_COUPON: "Use Coupon?",
    UPDATE_EXP_DATE :"Update Expiry Date",
    TOTAL_PRICE: "Total Price",
    DISCOUNT: " Discount(-)",
    DISCOUNT_PERCENT:"Discount(%)",
    START_DATE:"Start Date",
    TOTAL: "Total",
    PAY: "PAY",
    COUPON_CODE: "Coupon Code:",
    COUPON_NAME: "Coupon Name",
    COUPON_CODE_1: "Coupon Code ",
    PAYMENT_SUMMARY:"Payment Summary",
    CONTINUE: "Continue",
    RETRY_PAYMENT: "Retry Payment",
    APPLY: "Apply",
    REMOVE: "Remove",
    ENTER_COUPON_CODE: "Enter Coupon Code",
    ERROR_IN_PAYMENT:"Error in payment status retrival",
    PAYMENT_TERMINATE: "Error in payment terminate",
    TRANSACTION_NUMBER: "Transaction Number:",
    AMOUNT:"Amount",
    MEMBERSHIP_PLAN: "Membership Plan",
    DATE_AND_TIME: "Date & Time",
    PAYMENT_MODE:"Payment Mode",
    STATUS_DESCRIPTION: "Status Description",
    MY_ORDERS_ALL:"All",
    MY_ORDERS_PAID:"Paid",
    MY_ORDERS_FAILED:"Failed",
    MY_ORDERS_PENDING:"Pending",
    PAYMENT_ABORTED:"Aborted",
    DATE: "Date",
    TRANSACTION_ID:"Transaction ID",
    ORDER_ID:"Order ID",
    PAYMENT_STATUS:"Status",
    PAYMENT_LAST_UPDATED:"Last Updated On",
    PAYMENT_RECEIPT:"Receipt",
    BASIC_INFO: "Basic Info",
    CHANGE_PASSWORD: "Change Password",
    SETTINGS : "Settings",
    CANNOT_UNDO_ACTION: "You cannot undo this action",
    HEALTH_RECORD_DELETED: "All your health records will be deleted. All your profile information will be deleted.",
    DELETE_ACCOUNT: "Delete Account",
    ACCOUNT_DELETED: "Account Deleted",
    RETAIN_YOUR_ACCOUNT: "We will retain your account information with us for the next 30 days. You can recover your account on or before",
    NAME:"Name",
    EMAIL_ID: "Email ID",
    MOBILE_NUMBER: "Mobile Number",
    TIME_ZONE: "Time Zone",
    LANGUAGE : "Language",
    PLEASE_SELECT_LANGUAGE: "Please select language",
    UPDATE: "Update",
    PLEASE_SELECT_TIME_ZONE: "Please select time zone",
    SEND_OTP: "SEND OTP",
    ENABLE_WATSAPP_SETTINGS: "Enable WhatsApp Notifications",
    BOOK_APPOINTMENT: "Book Appointment",
    PSYCHIATRIST: "Psychiatrist",
    AGE: "Age",
    COLON: ":",
    DOB_CAPS: "DOB",
    GENDER: "Gender",
    CREATE_NEW_ACCOUNT: "Create New Account",
    RELATION_WITH_CARE_RECEIVER: "Relationship with Care Receiver",
    MOBILE: "Mobile",
    ACCOUNT_HOLDER_FIRST_NAME: "Account Holder First Name",
    ACCOUNT_HOLDER_LAST_NAME: "Account Holder Last Name",
    CARE_RECEIVER_NAME: "Care Receiver Name",
    CARE_RECEIVER_FIRST_NAME : "Care Receiver First Name",
    CARE_RECEIVER_LAST_NAME : "Care Receiver Last Name",
    MALE: "Male",
    FEMALE: "Female",
    OTHERS: "Others",
    RECEIVER_NAME: "Name of Care Receiver",
    DOB: "Date of Birth ",
    DATE_FORMAT: "YYYY-MM-DD",
    DATE_FOOTER_MESSAGE: "Select or Enter the date to get updated",
    HI: "Hi",
    REGISTRATING_WITH_US: "By registering with us,",
    YOU_AGREE: "you agree to the",
    ON_BEHALF_OF_CARE_RECEIVER: "On Behalf of Care Receiver",
    TERMS_AND_CONDITION: "Terms and Conditions,",
    PRIVACY_POLICY: "Privacy Policy.",
    AGREE_TO: "Agree to",
    CONSENT_FORM_TITLE: "Parental Consent for Child/Adolescent Health Treatment",
    CONSENT_FORM_CONTENT_1: "Treatment methods are most effective when a trusting relationship exists between the child/adolescent and the doctors. It is hence necessary for children/adolescents to establish a “zone of privacy” with their doctors allowing them to discuss personal matters freely.",
    CONSENT_FORM_CONTENT_2: "Therefore, while we will provide you with general information about the treatment of your child/adolescent during Parental Check in sessions, it may not be possible to share everything that your child/adolescent has disclosed to us as we are dictated by the medical code of conduct and privacy, akin to any client-healthcare  provider relationship.",
    CONSENT_FORM_CONTENT_3: "However, if the child/adolescent is at serious risk of harming him/herself or another, or if there are any other issues of medico-legal implications, we will definitely inform you.",
    CONSENT_FORM_CONTENT_4: "In case of disagreement among parents themselves and/or disagreement between parents and the doctors regarding the treatment of the child/adolescent, and despite earnest efforts to address these disagreements, if either parent decides to terminate treatment, we shall request the option of having a few closing sessions with the child/adolescent to end treatment appropriately without adversely impacting the child/adolescent’s health.",
    CONSENT_FORM_CONTENT_5: "You will also kindly understand and agree that our role is strictly limited to providing sessions for the benefit of your child/adolescent health and wellness care. Please treat anything said in Parental check-in sessions as strictly confidential. You agree that you will not involve us in any legal dispute,especially those concerning parental separation/divorce proceedings, child custody or visitation arrangements. We are ethically bound not to give our opinion about the suitability of either parent's custody or visitation rights. You will not ask us to testify in court, either in person or by affidavit.",
    CONSENT_FORM_CONTENT_6: " If you have any questions about the information contained in this contract, please discuss them with us prior to signing below.Clicking yes indicates that you have a) obtained the assent of your child/adolescent implying his approval for his treatment and b) you hereby give your consent to your child/adolescent's health assessment and treatment and have thereby entered into a legally binding agreement with the terms set forth in this contract.",
    ACCEPT: "Accept",
    READ_PRIVACY_POLICY: "Please read Privacy Policy, Terms and Conditions",
    VALIDATION_MESSAGE: "This field cannot be empty",
    CREATING_NEW_ACCOUNT_DOT: "Creating New Account...",
    ADD_NEW_MEMBER: "Add New Member",
    CONTINUE_MODAL_TITLE: "Please Accept our updated policies to continue",
    PARENT_GUARDIAN_NAME: "Parent/Guardian Name",
    ACCEPT_TERMS_OF_USE: "Accept Terms of Use",
    ACCEPT_PRIVACY_POLICY: "Accept Privacy Policy",
    YEARS: "Years",
    SUBMITTING: "Submitting...",
    SUBMIT: "Submit",
    LEVEL: "Level",
    SCORE: "Score",
    YOUR_SCORE_INDICATES: "Your Score Indicates",
    OF: "of",
    FOR: "for",
    OUT_OF_18: "out of 18",
    BOTTOM_TITLE_PART_1: "Your scores indicate",
    ANXIETY_AND: "Anxiety and",
    DEPRESSION_SYMPTOMS: "Depression symptoms!",
    IGD: "IGD",
    ADHD: "ADHD and",
    OCD: "OCD symptoms!",
    SELF_ASSESSMENT_RESULT: "Your result for Self Assessment",
    BOTTOM_INFO_1: "These are self-reported scores, and these responses have to be validated and confirmed by a clinician upon a thorough evaluation.",
    PAYMENT_INVOICE:"Invoice",
    GUEST_USER_LANDING_DESCRIPTION: "Kindly login or sign up to know your assessment result.",
    NO_DATA_CONTENT_MONTH: "No Assessment taken yet!",
    NO_DATA_CONTENT_YEAR: "You have not taken any assessment for the current year.",
    NO_DATA_CONTENT_PAST_YEAR: "You have not taken any assessment for the past years.",
    CONSULTATION_FOR_UPCOMING: "You don't have an upcoming appointment.",
    CONSULTATION_FOR_CURRENT_MONTH: "You have not taken any appointment.",
    NO_CONSULTATION_FOR_UPCOMING: "No upcoming appointment.",
    NO_CONSULTATION_FOR_PAST: "No past appointment.",
    SUBSCRIBED_SUCCESSFULLY: "Plan subscribed successfully!",
    ERROR_DURATION_SUBCRIPTION: "Error during subscription!",
    HI_ALERT_MSG:"Kindly click on the Dashboard option from the Menu to proceed further.",
    HI_ALERT_MSG_UPLOAD_DOC:"To upload any medical document.",
    IHI_FORMAT_MSG:"File must be jpeg/jpg, png, or pdf.",
    IHI_TOOLTIP:"The information furnished in these sections is protected and shall be accessible only to the Care Team.",
    IHI_VALIDATION_MSG:"This field is required",
    IHI_ON_FINISH_ERR_MSGG:"Fill the duration of problem",
    PREVIOUS: "Previous",
    NEXT: "Next",
    VALID_UPTO: "Valid upto: ",
    ENDED_ON: "Ended on: ",
    SHOW_DOCS:"Showing all the documents.",
    UPLOAD_OTHER_DOCS:"Upload Other Documents",
    DOC_REQ_DOCS:"Doctor Requested Documents",
    ADD_NEW_DOC:"Add New Document",
    MY_PROFILE_HEADING_MESSAGE:"Review and update your details here",
    ADD_NEW_MEMBER_SUB_1: "Let’s get your account set up",
    ADD_NEW_MEMBER_SUB_2: "To make sure we get this right, we need some basic details and guardian’s consent.",
    SWITCH_ACCOUNT: "Switch Account",
    CHOOSE_A_PROFILE: "Choose a profile or create a new one",
    DEPENDANT_DETAILS: "Dependant Details",
    ENTER_THE_DETAILS: "Enter the details of dependant",








    PATIENT_UID: "Patient UID",
    PATIENT_NAME: "Patient Name",
    mobile_number:"mobile number",
    name:"name",
    email:"email",
    TIMER:179000,
    // TIMER:5000,
    PLAN: "Plan",
    APPOINTMENT: "Appointment",
    START_CONSULTATION: "Start consultation",
    CLICK_START_TO_BEGIN: "Click start to begin the consultation with",
    SEARCH_BY_PATIENT: "Search by patient...",
    PROFILES: "Profiles",
    TICKET_ID: "Ticket ID",
    TICKET_TYPE: "Ticket Type",
    TICKET_RAISED_ON: "Ticket Raised On (UTC)",
    CARE_TEAM: "Care Team",
    STATUS: "Status",
    RESOLVE: "Resolve",
    CALL_DETAILS: "Call Details",
    PATIENT_CONTACT: "Patient Contact",
    DOCTOR: "Doctor",
    PATIENT: "Patient",
    CALL: "Call",
    REFRESH: "Refresh", 
    ACCOUNT_HOLDER_DETAILS: "Account Holder Details",
    EMAIL: "Email",
    PATIENT_DETAILS: "Patient Details",
    CONTACT_INFO: "Contact Info",
    AGE_GROUP: "Age Group",
    CONSULTATION_RATING: "Consultation Rating",
    CALL_RATING: "Video Call",
    APP_RATING: "App",
    CONSULTATION_COMMENTS: "Consultation: ",
    PATIENT_VIDEO_CALL_FEEDBACK: "Patient Video Call Feedback",
    ACCOUNT_TYPE: "Account Type",
    CALL_STATUS: "Call Status",
    GET_LIVE_STATUS: "Get Live Status",
    DOCTOR_JOIN_STATUS: "Doctor Join Status",
    PATIENT_JOIN_STATUS: "Patient Join Status",
    CALL_TIME: "Call Time",
    CONSULTATION_LIST: "Consultation List",
    TICKET_LIST: "Ticket List",
    PATIENT_RECORDS: "Patient Records",
    THIS_MONTH: "This Month",
    THIS_YEAR: "This Year",
    PAST_YEAR: "Past Year",
    ASSESSMENT_HISTORY: "Assessment History",
    CONSULTATION_HISTORY: "Consultation History",
    SCHEDULE_YOUR_APPOINTMENT: "Schedule Your Appointment",
    MY_PROFILE: "My Profile",
    CONSULTATION_DATE: "Consultation Date",
    RESCHEDULE_APPOINTMENT: "Reschedule Appointment",
    CANCEL_APPOINTMENT: "Cancel Appointment",
    VIDEO_CALL: "Video Call",
    DOCUMENT_TYPE: "Document Type",
    DESCRIPTION: "Description",
    ACTION: "Action",
    VIEW: "View",
    EDIT: "Edit",
    DELETE: "Delete",
    UPLOAD: "Upload",
    SUBSCRIBE: "Subscribe",
    RENEW: "Renew",
    UPGRADE: "Upgrade",
    CHOOSE: "Choose",
    TAKE_OUR_SELF_ASSESSMENT: "Take Our Self Assessment",
    SELECT_ASSESSMENT_LANDING_DESCRIPTION: "These are internationally validated questions to assess the symptoms and their degree. However, these are not conclusive diagnostic methods and should be verified by a clinician.",
    ASSESSMENT_LANDING_DESCRIPTION: "These are internationally validated symptom checklists used for the detection of depression and anxiety symptoms. These should take less than 3 minutes to complete.",
    ASSESSMENT_LANDING_DESCRIPTION_ADOLESCENT: "Take a 2-minute quiz to learn if your teen's behaviour is normal, or a sign of a deeper issue.",
    ASSESSMENT_LANDING_DESCRIPTION_STRESS: "Please answer the following questions to know the presence and degree of stress.",
    ASSESSMENT_LANDING_DESCRIPTION_1: "Please answer the questions based on how the child has been feeling in the past 3 months.",
    ASSESSMENT_LANDING_DESCRIPTION_2_PART_1: "Please answer the questions based on how you have been feeling in the past",
    ASSESSMENT_LANDING_DESCRIPTION_2_PART_2: "You can take this test every 15 days.",
    ASSESSMENT_LANDING_DESCRIPTION_STRESS_1: "Please answer the questions based on how you have been feeling in the past 3 months.",
    ASSESSMENT_LANDING_DESCRIPTION_OTHERS_1: "Please answer the questions based on how you have been feeling in the past 2 weeks.",
    ASSESSMENT_LANDING_DESCRIPTION_SENIOR_ADULT_1: "Please answer the questions based on how you have been feeling in the past 1 month.",
    MONTHS: "months",
    MONTH: "month",
    WEEKS: "weeks",
    ASSESSED_ON: "Assessed on",
    SCHEDULE_YOUR_APPOINTMENT: "Schedule Your Appointment",
    // SELECT_DATE_TIME_SLOT: "Selected Date and Time slot",
    SELECT_DATE_TIME_SLOT: "Selected Slot",
    SELECT_DOCTOR: "Select Doctor",
    MY_PROFILE: "My Profile",
    MY_ORDERS:"My Orders",
    MY_ORDERS_SUCCESS:"Success",
    MY_ORDERS_FAILURE:"Failure",
    CLOSE: "Close",
    BOTTOM_INFO: "Get to know more by having an evaluation call with our Clinician.",
    GO_TO_APPOINTMENTS:"Go to Appointments",
    APPOINTMENT_CONFORMATION: "Appointment Confirmation",
    APPOINTMENT_REVIEW_TITLE: "Confirm your appointment with",
    SCHEDULED_TIME: "Scheduled Time",
    CALL_DURATION: "Call Duration",
    APPOINTMENT_REVIEW: "Appointment Review",
    WRAPPER_HEADER: "Appointments to be Revised",
    SCHEDULE_TIME: "Schedule Time",
    CASESHEET: "Casesheet",
    CONSULT: "Consult",
    PRESCRIBE: "Prescribe",
    TODAY: "Today",
    UPCOMING_APPOINTMENT : "Upcoming Appointment",
    PAST_APPOINTMENT : "Past Appointment",
    CONSULTATION_TO_BE_DONE: "Consultations to be done",
    CONSULTATION_DONE: "Consultations done",
    AVAILABILITY: "Availability",
    // DOCTOR_CONTENT: "will be available in the following time slots (local time).",
    DOCTOR_CONTENT: "is available in the following alternative time slots(local time).",
    NO_SLOTS: "No slots are available for",
    RESCHEDULE_TITLE: "This will create a request for rescheduling an appointment. Our care admin will reach out to you for a new appointment. Do you wish to proceed?",
    CANCEL_TITLE: "This will create a request for cancelling an appointment. Do you wish to proceed?",
    YES: "Yes",
    NO: "No",
    PHI_CENTER_TEXT: "You have not filled Health Information details yet!",
    NO_SLOTS_AVAILABLE: "No time slot is available.",
    NOT_SCHEDULED_APPOINTMENT: "You have not scheduled any appointments yet!",
    SUBSCRIPTION_MESSAGE: "Continue with our  Wellness Program to maintain your health",
    PRIZE_TYPE: "/month",
    PLAN_DETAILS: "Membership benefits includes",
    MY_CONSULTATIONS: "My Consultations",
    // TODAYS_APPOINTMENT: "Today's Appointments",
    TODAYS_APPOINTMENT: "Appointments",
    VIEW_ALL:"View All",
    VIEW_PAST: "View Past",
    VIEW_UPCOMING: "View Upcoming",
    APPOINTMENT_NO_DATA_CONTENT: "No appointments scheduled for today!",
    MY_AVAILABILITY: "My Availability",
    AVAILABILITY_SUB_CONTENT_HEADER: "Provide  available timing for patients to book appointments.",
    AVAILABLE_DAYS: "Available Days",
    AVAILABILITY_SUB_CONTENT_HEADER_1: "Mention  leave days to skip appointments.",
    HOLIDAYS: "Leave Days",
    CLICK_TO_PROCEED: "Click to proceed",
    DOCTOR_AVAILABILITY: "Available days and time slots",
    AVAILABILITY_DOCTOR_POPUP_1: "Enter your planned non-working days",
    AVAILABILITY_DOCTOR_POPUP_2: "Enter your working days in a week",
    ADD_HOLIDAY: "Add Leave Days",
    ADD_AVAILABILITY: "Add Availability",
    OTP_EMAIL: "Enter the OTP sent to your mail",
    OTP_EMAIL_ID: "Enter the OTP sent to your mail ID",
    SUBMIT_CAPS: "SUBMIT",
    VERIFYING_OTP: "Verifying Otp...",
    VERIFY_OTP: "VERIFY OTP",
    MULTI_DOC: "Custom Document",
    CASENOTES: "Casenotes",
    ADD_CASENOTES: "Add Casenotes",
    ADD_PSYCHIATRIC:"Add Psychiatry Feedback Report",
    PST:"PFR",
    PST_RPT:"Psychiatry Feedback Report",
    DOTS: "DOTS",
    MSE: "MSE",
    MSE_FULLFORM:"Mental Status Examination",
    EXPIRY_DATE_TIME:"Expiry Date Time",
    MHE_BLOCK_1: "PRE-MORBID CHECKLIST",
    PRE_MORBID_CHECKLIST_LABEL: "Attention, Persistence, Frustration Tolerance",
    NORMAL_UNIMPAIRED: "Normal/Unimpaired",
    MILDLY_IMPAIRED: "Mildly Impaired",
    MARKEDLY_IMPAIRED: "Markedly Impaired",
    COGNITIVE: "'C'ognitive",
    EXAMINATION_ASEPTIC: "EXAMINATION ('ASEPTIC')",
    MSE_SUB_BLOCK: "'A'ppearance, Behaviour, Motor Activity",
    GOOD: "Good",
    POOR: "Poor",
    NORMAL: "Normal",
    FAIR: "Fair",
    REDUCED: "Reduced",
    OVERFRIENDLY: "Overfriendly",
    ABSENT: "Absent",
    PRESENT: "Present",
    SPEECH: "'S'peech",
    SPEECH_LANGUAGE: "Speech and Language",
    PRESSURED: "Pressured",
    SLOWED: "Slowed",
    JARGON_NEOLOGISMS: "Jargon / Neologisms",
    EMOTION: "'E'motion",
    EUTHYMIC: "Euthymic",
    DEPRESSED: "Depressed",
    ELATED: "Elated",
    ANXIOUS: "Anxious",
    NORMAL_RANGE: "Normal Range",
    STABLE: "Stable",
    CONSTRICTED: "Constricted",
    LABILE: "Labile",
    PERCEPTION: "'P'erception",
    HALLUCINATION: "Hallucinations",
    THOUGHT: "'T'hought",
    FORM_AND_CONTENT: "Form & Content",
    PATIENT_HISTORY: "Patient History",
    ANXIETY_LEVEL: "Anxiety Level",
    DEPRESSION_LEVEL: "Depression Level",
    STRESS_LEVEL: "Stress Level",
    ADD_ICON: "Click the + icon to fill information",
    DSM_SCREENING: "DSM",
    BRIEF_PSYCHOTHERAPEUTIC_INTAKE: "Brief Psychotherapeutic Intake",
    DIAGNOSIS: "Diagnosis",
    THERAPHY_PRGORESS : "Therapy Progress Note",
    PSYCHOLOGICAL_FLEXIBILITY_RATING : "Psychological Flexibility Rating",
    PSYCHOTHERAPY_GOAL : "Psychotherapy Goal",
    TREATMENT_PLAN: "Treatment Plan",
    PROTECTIVE_FACTOR: "Protective Factors",
    DOTS_SMALL: "Dots",
    SOS_SMALL: "Sos",
    TRANSCRIPTION: "Transcription",
    ADD_PRESCRIPTION: "Add Prescription",
    ADD_DSM_SCREENING: "Add DSM",
    ADD_MSE: "Add MSE",
    ADD_BRIEF_PSY: "Add Brief Psychotherapeutic Intake",
    ADD_THERAPHY_PROGRESS : "Add Therapy Progress Note",
    ADD_DIAGNOSIS: "Add Diagnosis",
    ADD_PROTECTIVE_FACTOR: "Add Protective Factors",
    ADD_DOTS: "Add DOTS",
    ADD_SOS: "Add SOS",
    ADD_TREATMENT_PLAN: "Add Treatment Plan",
    PUBLISH: "Publish",
    TOTAL_CONSULTED: "Total Consulted",
    MISSED_PRESCRIPTION: "Missed Prescriptions",
    MISSED_CASENOTES: "Missed Casenotes",
    MISSED_PRESCRIPTION_PUBLISH: "Missed Prescriptions Publish",
    MISSED_EVAL_REPORTS_PUBLISH: "Missed Evaluation Reports Publish",
    MY_PATIENTS: "My Patients",
    LAST_CONSULTATION_PATIENT_TABLE: "Last Consultation",
    NEXT_CONSULTATION: "Next Consultation",
    PLAN_DETAILS_TABLE: "Plan Details",
    // CASESHEET_SUMMARY: "Casesheet Summary",
    CASESHEET_SUMMARY: "Summary",
    ASSESSMENT_TABLE: "Assessment",
    HIGH: "High",
    AVERAGE: "Average",
    LOW: "Low",
    OPENNESS_LOW:"(Narrow field of interests, likes the tried and true) Low",
    OPENNESS_HIGH:"High (Imaginative, curious, open to new ideas)",
    CONSCIE_LOW : "(Impulsive, carefree) Low",
    CONSCIE_HIGH : "High (Responsible, dependable, goal oriented)",
    EXTRA_LOW:"(Quiet, withdrawn, unassertive) Low",
    EXTRA_HIGH:"High (Outgoing, energetic, gregarious)",
    AGREE_LOW:"(Aloof, easily irritated) Low ",
    AGREE_HIGH:"High (Warm, considerate, good natured)",
    NEURO_LOW:"(Moody, tense, lower self-confidence)Low",
    NEURO_HIGH:"High(Stable, confident)",
    HYPERACTIVE: "Hyperactive",
    PERSONALITY_TRAITS_OCEAN: "PERSONALITY TRAITS ('OCEAN')",
    MILD: "Mild",
    SEVERE: "Severe",
    SAD:"Sad",
    HAPPY: "Happy",
    INSIGHT: "'I'nsight",
    STATIC_TITLE_DSM: "Additional screening for Psychiatric symptoms (DSM)",
    QUESTION_TITLE_DSM: "All questions to be answered 'yes' or 'no' with reference to the past 2 weeks.",
    SUBSCRIBE_TO: "Subscribed to",
    ASSESSMENT_SETTINGS: "Assessment Settings",
    SAVE: "Save",
    ASSESSMENT_SCORE: "Assessment Score",
    BASED_ON_RECENT_ASSESSMENT: "Based on the recent assessment done",
    NO_ASSESSMENT_TAKEN: "No Assessment taken yet!",
    SOS_CAPS: "Symptoms Of Stress",
    APPOINTMENT_CONSULTATION: "Appointment / Consultation",
    HAVE_COMPLETED: "Have completed",
    MEDICINES_PRESCRIBED: "Medicines prescribed on last consultation",
    CASESHEET_EDITED: "Casenotes last edited on ",
    VIEW_CASESHEET: "View Casenotes",
    SECTION_OF_HI_SUMMARY: "Section of HI Summary",
    VIEW_SUMMARY: "View Summary",
    ADD_ANSWER: "Add Answer",
    PSY_QUESTION_TITLE: "There are contrasting statements at either end and numbered 1-10. For each scale, choose where you would place yourself by selecting a number depending on how closely, you feel the statements apply to you. If you feel that both the statements apply equally, or that neither statement applies to you, score 5. This rating will help to understand you better and know which area you would need to work on more.",
    PSY_QUESTION_TITLE1_ADOLESCENT: "Here we have six double-headed arrows, numbered 1-10. For each scale, choose where you would place yourself by selecting a number depending on how closely, you feel the statement applies to you.",
    PSY_QUESTION_TITLE2_ADOLESCENT: "For e.g. If you feel the statement does not apply to you at all select 1 for never, or if it applies to you approximately 50 percent of the times, select 5. This rating will help us to understand you better and know which area you would need to work on more.",
    PSY_QUESTION_FEEDBACK1:"What is your understanding of how counselling or psychotherapy can help to work on the problem? Willingness to work on one's mental health?",
    PSY_QUESTION_FEEDBACK1_ADOLESCENT:"What is maintaining the problem?",
    PSY_QUESTION_FEEDBACK2_ADOLESCENT:"How can psychotherapy help?",
    SPECIFIC_REASON: "Specific Reason if Low?",
    SUITABILITY_RATING: "Suitability Rating",
    COLLABORATION_RATING: "Collaboration Rating",
    TIMEZONE_WARNING_1:"Your preferred Timezone is GMT",
    TIMEZONE_WARNING_2:" and current Timezone is GMT",
    TIMEZONE_WARNING_3:"Do you want to switch your Timezone?",
    PRESCRIPTION_NOT_CREATED : "*Your prescription was not published. Please reach out to our care admin for any queries.",
    PRESCRIPTION_NOT_CREATED_CARE_ADMIN : "*Prescription was changed/not created and not published. Contact doctor.",
    FORGOT_YOUR_PASSWORD: "Forgot Your Password",
    PREVIEW_EVAL_REPORT:"Preview Psychological Feedback Report",
    PREVIEW_PST_REPORT:"Preview Psychiatry Feedback Report",
    USER_TYPE: "User Type",
    YES_I_REQUIRING_CARE: "Yes. I am the one requiring care.",
    NO_CREATING_FOR_SOMEONE: "No. I am doing on behalf of someone else who needs the care.",
    SEND_OTP_SMALL: "Send OTP",
    VERIFY_OTP_SMALL: "Verify OTP",
    OPTIONAL_MESSAGE_LOGIN: "Already have an account? ",
    FORGOT_PASSWORD: "Forgot Password",
    EMAIL_ID_MOBILE_NUMBER: "Email ID/MobileNumber",
    BACK_TO_LOGIN: "Back to Login",
    SENDING_OTP_DOT: "Sending Otp...",
    LOGIN_TO_ACCOUNT: "Login to your account",
    EMAIL_ID_MOBILE: "Email ID/Mobile",
    PASSWORD: "Password",
    FORGOT_PASSWORD_QUESTION: "Forgot Password?",
    LOGGING_IN_DOT: "Logging In...",
    LOGIN: "LOGIN",
    LOGIN_WITH_PASSWORD: "Login with Password",
    LOGIN_WITH_OTP: "Login with OTP",
    DONT_HAVE_ACCOUNT: "Don't have an account?",
    VERIFYING_DOT: "Verifying...",
    VALIDATION_MOBILE_MESSAGE: "Please enter Email/Mobile number",
    VALIDATION_EMAIL_MESSAGE: "Please enter your email",
    VALIDATION_MOBILENUMBER_MESSAGE: "Please enter your mobile number",
    OR: "or",
    COUPON_USAGE:"Usage",
    STARTED_WITH_ASSESSMENT: "What brings you to",
    DEPRESSION_ANXIETY_TEENS: "HealthEdge for Teens - Adolescent Mental Health Care",
    DEPRESSION_ANXIETY_ADULT: "Assessment and Holistic Treatment (Anxiety/Depression/Insomnia)",
    STRESS_ADULTS: "Preventive Mental Wellness - Stress Management",
    SIGN_UP: "Sign Up",
    LOGIN_SMALL: "Login",
    USER_NOT_ALLOWED: "User was not allowed to Login",
    USER_NOT_REGISTERED: "User not Registered with us",
    OTP_SENT_SUCCESSFULLY: "OTP sent successfully!",
    LOGGED_IN_SUCCESSFULLY: "Logged in successfully!",
    LOGIN_ASSESSMENT_INCOMPATIBLE: "The login user type and the self assessment type were incompatible. Prior assessment taken before logging in was not added to your profile.",
    INVALID_OTP: "Invalid OTP. Please re-enter OTP or use Re-send OTP option.",
    SUCCESSFULLY_VERIFIED: "Successfully Verified",
    FIELD_REQUIRED: "This Field is Required",
    INVALID_SELF_ASSESSMENT: "Invalid self-assessment. This self-assessment is not applicable for your profile.",
    YOU_ARE_NOT_ELIGIBLE: "You are not eligible for this self-assessment, your next",
    STRESS_SMALL: "stress",
    ASSESSMENT_ON_SMALL: "assessment on",
    DEPRESSION_ANXIETY_SMALL: "depression/anxiety",
    LOGOUT: "Are you sure you want to logout?",
    CAPS_LOGOUT: "LOGOUT",
    LOGGING_OUT: "Logging Out...",
    CHAT_TEXT: ", Welcome to HealthEdge. I am here to help you.",
    PLEASE_SELECT_DOCTOR: "Please select the doctor.",
    RESEND_OTP_IN: "Resend OTP in",
    RESEND_OTP: "Resend OTP",
    VOICE_OTP: "Get OTP on call",
    DIDNOT_RECEIVE_OTP: "Didn't receive OTP?",
    TROUBLE_RECEIVING_OTP: "Trouble Receiving OTP in SMS?",
    CASESHEET_UPDATE_ERROR_MESSAGE: "Please submit/update the casenotes",
    PLEASE_ENTER_NOTES: "Please enter notes!!",
    NO_DATA_FOUND: "No data found",
    SERVICE_REQUIRED_PLACEHOLDER: "Is this service required for you or someone else?",
    YOUR_EMAIL: "Your Email",
    YOUR_MOBILE: "Your Mobile",
    NO_DATA: "No Data",
    FILE_FORMAT_ERROR_MESSAGE_1: "File format must be JPEG/PNG/PDF",
    FILE_FORMAT_ERROR_MESSAGE_2: "File must not exceed 5 MB",
    YOU_CAN_UPLOAD: "You can upload only JPG/PNG/PDF format",
    FILE_SIZE: "File size must be smaller than 2MB",
    FILE_SIZE_25: "File must not exceed 25MB size",
    CONFIRMATION: "Confirmation",
    DELETE_SURE_MESSAGE: "Are you sure you want to delete it?",
    KINDLY_SELECT_DASHBOARD_OPTION: "Kindly click on the Dashboard option from the Menu to proceed further.",
    DASHBOARD: "Dashboard",
    PRESENTING_MENTAL_HEALTH_PLACEHOLDER: "Explain in your own words...",
    CONTEXT_OF_PROBLEMS: "Context of Problems/Concerns/Difficulties",
    PHYSICAL_ILLNESS: "Physical Illness (Past/Present)",
    PAST_MENTAL_ILLNESS: "Past Mental Illness",
    EDUCATIONAL_DETAILS: "Education Details",
    OCCUPATIONAL_DETAILS: "Occupational Details",
    EDUCATIONAL_LEVEL: "Educational Level",
    OCCUPATION: "Occupation",
    PRESENTING_COMPLAINT: "Presenting Complaints",
    DETAILS_SAVE_SUCCESSFULLY: "Details saved successfully!",
    UPLOADING: "Uploading...",
    FILE_FORMAT: "(File format: JPEG, PNG, PDF)",
    MAX_FILE_SIZE: "(Max file size: 25 MB)",
    LOADING: "Loading...",
    SELECT: "Select",
    ADD_MEDICATION: "Add Medication",
    ADD_RELATIONSHIP: "Add Relationship",
    PLEASE_TYPE_HERE: "Please type here",
    QUANTITY: "Quantity",
    SINCE: "Since",
    REASON_FOR_RELAPSE: "Reason for relapse",
    WITHDRAWAL_SYMPTOMS: "Withdrawal Symptoms",
    ABSTINENCE: "Abstinence",
    SPECIFY: "Specify",
    RELATIONSHIP: "Relationship",
    DURATION: "Duration",
    FREQUENCY: "Frequency",
    TYPE_HERE: "Type here",
    CONDITION: "Condition",
    PLEASE_MENTION: "Please mention",
    ILLNESS_CONDITION: "Illness/Condition",
    MEDICATION: "Medication",
    DOSAGE: "Dosage",
    STARTING_YEAR: "Starting Year",
    CARE_TEAM_CONTEXT_OF_PROBLEMS: "Context of Problems/Concerns/Difficulties(Care Team)",
    OTHER: "Other",
    EXPLAIN_IN_YOUR_OWN_WORDS: "Explain in your own words - the symptoms, issues bothering you...",
    RECENT_EVENT_IN_PARENTS_LIFE: "Recent Events in Parents Life",
    SUBSTANCE_USE: "Substance Use",
    IF_YES_SPECIFY: "If Yes, Specify",
    KG_M: "kg/m",
    TWO: "2",
    UPLOAD_DOCUMENT: "Upload Document",
    CM: "cm",
    KG: "kg",
    SOMETHING_WENT_WRONG: "Oops! Something went wrong.",
    EXP: "Exp:",
    SELECT_DOMAIN: "Select domain",
    PLEASE_SELECT_ACTIVITY: "Please select a activity type.",
    CLICK_TO_START: "Click to start",
    MY_TICKETS: "My Tickets",
    NO_TICKETS_AVAILABLE: "No Tickets Available",
    DOCTORS_NOT_AVAILABLE: "Doctors not available!!",
    DOCTOR_ASSIGNED: "Doctor assigned successfully!",
    ERROR_MESSAGE_1: "Please select a Doctor or Cancel!",
    ERROR_MESSAGE_2: "Please select Date and Time!",
    SUCCESSFULLY: "successfully!",
    SCHEDULED_DATE_TIME: "Please schedule with Date and Time !!",
    TICKET_RESOLVED: "Ticket resolved successfully!",
    TICKET_SNOOZED: "Ticket snoozed successfully!",
    SELECT_DOCTOR_EXCLAMATION: "Please select a Doctor!",
    ERROR_MESSAGE_3: "Once submitted, this appointment will be scheduled to",
    CHOOSE_ONE_OR_MORE: "Choose one or more ticket types to resolve",
    PLEASE_SELECT_TICKET: "Please select a ticket type before proceeding.",
    SEARCH: "Search",
    RESET: "Reset",
    INACTIVE: "Inactive",
    JOINED: "Joined",
    YET_TO_JOIN: "Yet to Join",
    NOT_JOINED: "Not Joined",
    ENTER_THE_REGISTERED: "Enter the registered ",
    CHOOSE_OPTION:"Choose any one option to proceed",
    TO_VIEW: "to view the patient details",
    EMAIL_ID_REQUIRED: "Email Id is required",
    NAME_REQUIRED: "Name is required",
    MOBILE_REQUIRED: "Mobile number is required",
    ADD_ON: "+91",
    ENTER_YOUR_EMAIL: "Enter your Email",
    ENTER_YOUR_NAME: "Enter your name",
    FOR_INDIVIDUAL:"For Individual",
    CARE_ADMIN_FOR_INDIVIDUAL:"Individual",
    FOR_INDIVIDUAL_DESCRIPTION:"Create an individual account",
    CARE_ADMIN_FOR_INDIVIDUAL_DESCRIPTION:"Create new individual account",
    ACTIVATE:"Activate",
    OFFL_PAT_COUPON_APPLY:"Apply coupon code, to activate One General Consultation plan*.",
    OFF_PAT_COUPON_APPLIED:" Activated One General Consultation Plan successfully!, proceed to Book Appoinment",
    RELATION_WITH_ACCOUNT_OWNER:"Relationship with account holder",
    ENTER_ACCH_LAST_NAME: "Enter Account holder's last name",
    ENTER_ACCH_EMAIL:"Enter Account holder's email",
    ENTER_ACCH_MOBILE:"Enter Account holder's mobile number",
    ENTER_ACCH_NAME: "Enter Account holder's name",
    ENTER_YOUR_LAST_NAME: "Enter your last name",
    ENTER_CARE_REC_NAME:"Enter Care receiver's name",
    ENTER_CARE_REC_LNAME:"Enter Care receiver's last name",
    ENTER_YOUR_MOBILE: "Enter Mobile Number",
    ENTER_EMAILID: "Enter Email ID",
    ENTER_NAME: "Enter Name",
    ENTER_MOBILE: "Enter Mobile Number",
    CARE_EMAIL_ID_REQUIRED: "Email ID is required",
    ERROR_IN_FETCHING: "Error in fetching table data:",
    EXPIRY: "Expiry:",
    EXPIRY_DATE:"Expiry Date ",
    SHOWING_TICKETS_FOR: "Showing Tickets For",
    STOP: "Stop",
    TICKET_ID_CAPS: "TICKET ID: #",
    OPEN_TICKET: "Open Ticket",
    WHATSAPP: "WhatsApp",
    LIKE_TO_CANCEL: "Would you like to cancel",
    LIKE_TO_CANCEL_SCHEDULE: "Would you like to Schedule/cancel",
    LIKE_TO_CANCEL_RESCHEDULE: "Would you like to reschedule/cancel",
    SELECT_DATE: "Select Date",
    SELECT_SLOT: "Select Slot",
    VIEW_PRESCRIPTION: "View Prescription",
    ERROR_MESSAGE_4: "Once Submitted, this appointment will be cancelled immediately",
    COMMENTS: "Comments",
    SELECT_ANY_REASON: "Select any reason",
    SNOOZ_FOR: "Snooze For",
    SELECT_ANY_ACTION: "Select any action",
    BASIC_INFORMATION_SMALL: "Basic information",
    VERIFY_EMAIL: "Verify Email ID",
    VERIFY_MOBILE: "Verify Mobile Number",
    SETUP_PROFILE: "Setup profile",
    ENTER_MAIL_MOBILE: "Enter your email id & mobile number",
    ENTER_OTP_MAIL: "Enter OTP sent to your Email ID",
    ENTER_OTP_MOBILE: "Enter OTP sent to your Mobile Number",
    CREATE_PERSONALISED: "Create your personalised profile",
    SELECT_USER_TYPE: "Select the user type",
    CREATE_AN_ACCOUNT: "Create an Account",
    CUSTOM_DIAGNOSIS:"Clinical Diagnosis",
    EXIS_AILMENT:"Existing Ailments",
    COMORBITIES:"Comorbidities",
    MED_NAME:"Drug",
    MED_BRAND_NAME:"Brand",
    MED_FORM:"Form",
    MED_DOSAGE:"Dosage",
    MED_ROUTE:"Route",
    MED_FREQUENCY:"Frequency",
    MED_DURATION:"Duration",
    MED_ADJUVANT:"Adjuvant",
    MED_INSTRUCTION:"Instruction",
    MED_EDIT:"Edit",
    MED_DELETE:"Delete",
    ALLOPATHY_PLEASE_SELECT: "Please select either Allopathy or Ayurveda Prescription type",
    ALLOPATHY_UPDATE_MSG: "Update or Cancel the previous edit to proceed further",
    ALLOPATHY_CANNOT_SUBMIT: "Cannot submit empty Prescription!",
    ALLOPATHY_UPDATE_OR_CANCEL: "Update or Cancel the previous edit to proceed further!!",
    ALLOPATHY_DRUG_TYPE: "Drug Type",
    FROM_DIAGNOSIS_FORM: "From Diagnosis form",
    NO_PREVIOUS_DIAGNOSIS: "No previous Diagnosis.",
    REVISED: "Revised",
    ADD_OR_EDIT: "Add/Edit Diagnosis here...",
    FORM_HI_FORM: "From HI form",
    BRAND_NAME: "Brand Name",
    DRUG_NAME: "Drug Name",
    SELECT_ROUTE: "Select Route",
    ORAL: "Oral",
    EXTERNAL_MASSAGE: "External/local application/massage",
    HEAD_MASSAGE: "For Head Massage",
    SUBLINGUAL: "Sublingual",
    INTRAVENOUS: "Intravenous",
    INTRAMUSCULAR: "Intramuscular",
    SUBCUTANEOUS: "Subcutaneous",
    RECTAL: "Rectal",
    INTRANASAL: "Intranasal",
    INHALATIONAL: "Inhalational",
    TRANSDERMAL: "Transdermal",
    INTRATHECAL: "Intrathecal",
    ADJUVANT: "Adjuvant",
    MG: "mg",
    ML: "ml",
    DAYS: "Day(s)",
    WEEK_S: "Week(s)",
    MONTH_S: "Month(s)",
    YEAR_S: "Year(s)",
    TABLET_S: "Tablet(s)",
    FORM: "Form",
    POWDER: "Powder",
    TABLET: "Tablet",
    CAPSULE: "Capsule",
    LIQUID: "Liquid",
    CREAM: "Cream",
    DROPS: "Drops",
    INHALER: "Inhaler",
    MEDICATED_GHEE: "Medicated Ghee",
    JAM_PASTE: "Jam/Paste",
    MEDICATED_OIL: "Medicated oil",
    MEDICATED_TAILA: "Medicated Taila",
    INSTRUCTION: "Instruction",
    ADD: "Add",
    ADDED_PRESCRIPTION: "Added Prescriptions",
    WOULD_YOU_LIKE: "Would you like to select any pre-defined set of prescriptions",
    PLEASE_SELECT_ROUTE: "Please select route type!",
    YOUR_ADDED_PRESCRIPTION: "Your added prescriptions will appear here",
    CLEAR_ALL: "Clear All",
    INSTRUCTION_COLON: "Instruction:",
    SELF_ASSESSMENT_ENABLED: "Self Assessment enabled every",
    FIFTEEN_DAYS: "15 days",
    SWITCH_TAB: "Switch Tab",
    UNSAVED_CHANGES: "There are unsaved changes. Are you sure to switch Tab?",
    CONSULTATION_FOR_CURRENT_YEAR: "You have not taken any consultation for the current year.",
    CONSULTATION_FOR_PAST_YEAR: "You have not taken any consultation for the past years.",
    CANNOT_SUBMIT_EMPTY: "Cannot submit empty form!",
    CHALLENGES: "Challenges",
    EMOTION_ASSESS: "Depression/Anxiety",
    SENIOR_ADULT:"Geriatric",
    EMOTIONAL: "Emotional",
    DIAGNOSIS_COGNITIVE: "Cognitive",
    BEHAVIOURAL: "Behavioural",
    PHYSICAL: "Physical",
    COMPETENCY: "Competency",
    TEST_FINDINGS: "Test Findings",
    FINDING_FOR_DSM: "Findings from DSM",
    IMPRESSION_DIAGNOSIS: "Impression / Diagnosis",
    CONTRIBUTING_MAINTAINING: "Contributing and Maintaining Factors",
    WELLNESS_GOAL: "Wellness Goal and Ayurvedic Approach to Diet",
    TO_BE_FAVOURED: "To be Favoured",
    TO_BE_AVOIDED: "To be Avoided",
    DIET_ADVISED: "Diet Advised",
    FAILED_TO_ADD_DESCRIPTION: "Failed to Add Description, Please try later",
    INSTRUCTION_GIVEN_BELOW: "Instructions given below will be displayed to care admin at the time of care team assignment.",
    FEEDBACK_PUBLISH:"Psychological Feedback Report for this consultation is published.",
    PSYCHIATRIC_PUBLISH:"Psychiatry Feedback Report for this consultation is published.",
    PRESCRIPTION_PUBLISH:"Prescription for this consultation is published.",
    PRESCRIPTION_PUBLISH_IN_PROGRESS:"Prescription publish is in progress for this consultation",
    PRESCRIPTION_WILL_BE_PUBLISHED:"Prescription publish is in progress will be published shortly.",
    INSTRUCTIONS: "Instructions",
    DOCTOR_REFERAL_ERR_MSG: "Please add Clinician name to refer!",
    SPECIALITY_NAME: "Speciality Name",
    SPECIALITY: "Speciality",
    SPECIALITY_DOCTOR: "Speciality Doctor",
    FREQUENCY_IN_WEEKS: "Frequency in Weeks",
    NEXT_APPOINTMENT_DATE: "Next Appointment Date:",
    NEXT_APPOINTMENT: "Your next Appointment will be on",
    PLEASE_SELECT_DATE: "Please select date!",
    APPOINTMENT_TIME: "Appointment Time:",
    YOUR_APPOINTMENT_TIME: "Your Appointment time will be at",
    PLEASE_SELECT_TIME: "Please select time!",
    SELECT_TIME: "Select Time",
    REACTION_TO_CRITICISM: "Reactions to criticism, provoking /stressful situation",
    REACTION_TO_STRESS: "Reactions to stress (Coping & Defense mechanisms)",
    AFFECT: "Affect",
    CASE_FORMULATION_1:"Case Formulation 1",
    CASE_FORMULATION_2:"Case Formulation 2",
    Add_Formulation_1:"Add Case Formulation 1",
    Add_Formulation_2:"Add Case Formulation 2",
    GEN_ASSESS:"General Assessment",
    DSM:"DSM",
    MSE:"MSE",
    PSY:"BPI",
    TPN:"TPN",
    PFACT:"P-FACT",
    DOTS:"DOTS",
    SOS:"SOS",
    CONCOG:"CONCOG",
    CONPSYQ:"CONPSYQ",
    CONFAS:"CONFAS",
    ADD_COUPON:"Add Coupon",
    ADD_CONFAS:"Add CONFAS",
    ADD_CONCOG:"Add CONCOG",
    ADD_CONPSYG:"Add CONPSYQ",
    STRESS_MNG:"Stress Management",
    GERIATRIC:"Geriatric",
    CF1:"CF-1",
    CF2:"CF-2",
    FEED_RPT:"Feedback Report",
    DIAGNOSIS:"Diagnosis",
    C_NOTES:"Case Notes",
    ESSENTIAL_Q:"Documents Upload",
    CONFAS:"CONFAS",
    CONPSYG:"CONPSYQ",
    CONCOG:"CONCOG",
    AI_FORM:"AI Form Assistant",
    ADD_ESS_Q:"Add Documents Upload",
    RX:"Rx",
    T_PLAN:"T-PLAN",
    UPLOAD_FILE:"Upload File",
    DOCS:"DOCS",
    DIAG:"DIAG",
    CNOTES:"C-NOTES",
    YES_CANCEL: "Yes, Cancel",
    YES_RESCHEDULE: "Yes, Reschedule",
    NO_PRESCRIPTION_REQUIRED:"No Prescription required for this consultation.",
    PREVIEW_PRESCRIPTION: "Preview Prescription",
    PRIEW_MEDICAL_TEST:"Preview Medical Test List",
    REVISED_DIAGNOSIS: "Revised Diagnosis",
    COMORBIDITIES_HI_FORM: "Comorbidities HI form",
    COMORBIDITIES_FROM_FORM: "Comorbidities from Form",
    REVISED_COMORBIDITIES: "Revised Comorbidities",
    ADD_OR_EDIT_COMORBIDITIES: "Add/Edit comorbidities here...",
    ALLOPATHY: "Allopathy",
    AYURVEDA: "Ayurveda",
    INCLUDE_HERBAL: "Include Herbal",
    HERBAL: "Herbal",
    ADD_NEW_DRUG: "+Add Medicine",
    SUMMARY: "Summary",
    PREDEFINED_MEDICINE: "Predefined medicine",
    CLINICIAN_COMMENTS: "Clinician's instructions/comments",
    SEARCH_BY_DIAGNOSIS: "Search by Diagnosis...",
    PERSONAL_GOALS : "Personal Challenges",
    ASSESSING_FLEXIBILITY : "Assessing Psychological Flexibility",
    FEEDBACK:"Feedback",
    PLAN_HISTORY:"Plan History",
    APPT_ACCEPTED_STS : "accepted",
    BRAND_DRUG: "Brand, Drug",
    PREVIEW_PUBLISH:"Preview & Publish",
    CHAT_CLOSED_MSG: "This chat is closed. If you wish to restart or continue, please close and open the chat window.",
    CHAT_CONNECT_FAILED_MSG: "Failed to connect chat. If you wish to restart or continue, please close and open the chat window.",
    CHAT_CLOSED_MSG_CA: "Oops! User has closed this chat session.",
    FEEDBACK_FORM: "Leave Your Feedback",
    CLINICAL_RATING: "Clinician Rating",
    CALL_RATING: "Call Rating",
    SUBMITTED: "Submitted",
    NOT_FILLED: "Not Filled",
    PUBLISHED: "Published",
    NOT_PUBLISHED: "Not Published",
    PRESCRIPTION_REPORT: "Prescription Report",
    P_FACT: "Protective Factors",
    DOCTOR_REFERRAL: "Doctor Referral",
    FINISH_CONSULTATION: "Finish Consultation",
    RESET_PASSWORD:"Reset Password",
    RESETTING_PASSWORD:"Resetting Password...",
    FINISH_CONSULTATION_HEADING: "Do you want to finish this consultation?",
    FOLLOW_UP: "Follow Up",
    SELECT_AGE: "Select your age",
    BEFORE_SINGUP: "Before signing up, confirm your age to access the",
    BELOW_18_YEARS: "Below 18 Years",
    ABOVE_18: "18 Years & Above",
    PREVIOUS_CONSULTATIONS_RATING:"Summary",
    CURRENT_CONSULTATIONS_RATING:"This Session",
    AGE_RESTRICTION: "Sorry, you are not eligible to create an account with",
    AGE_VERIFICATION: "Age Verification",
    NEED_HELP: "Need Help?",
    CONTACT_CARE_ADMIN: "Contact our Care admin ",
    SEND_EMAIL: "Send an email to our Care admin ",
    SUPPORT_NIYAMA: "support@HealthEdge.ai",
    CAREADMIN_NUMBER: "+91 93******64",
    MODE_ERROR:"Please select the mode.",
    REASON_ERROR:"Please add a reason. ",
    ADD_ENCOUNTER:"Add Zero Enounter",
    COMM_MODE:"Mode",
    APPOINTMENT_PLACEHOLDER:"Select Appointment Date and Time",
    REASON:"Reason",
    SELECT_APPOINTMENT_PLACEHOLDER:"Select Date and Time",
    SELECT_MODE:"Select Mode",
    ENCOUNTER_REASON:"Please add reason...",
    AVAILED_ON: "Planned sessions comp. on",
    AVAILED: "Planned sessions comp. date: ",
    CONFRIM_PRESCRIPTION_TYPE:"Selected Medication type as",
    CONFRIM_PRESCRIPTION_TYPE_DESCRIPTION:"Medication type cannot be modified after saving a prescription.",
    VIEW_REPORT: "View Report",
    EXPORT: "Export",
    CASE_SUMMARY_REPORT: "Case Summary Report",
    THIS_REPORT_WILL_AVAILABLE_FOR_24_HOURS: "This report will availabe for 24 hours",
    CASE_SUMMARY_REPORT_IS_IN_PROGRESS: "Case Summary Report generation is currently in progress",
    PROCEED: "Proceed",
    CHANGE_DATE_TIME_SLOT: "Change Date & Time slot",
    CHOOSE_YOUR_PREFERRED_TIME: "Choose your preferred alternative time slot",
    APPOINTMENT_MODAL_CONFORMATION_CONTENT: "Are you sure to proceed with the appointment on",
    SPEECH_TXT_ERR_MSG: "There seems to be a problem with audio",
    ASSESSMENT_HEADER: "Along with your regular reflection, assessing your current risk for common conditions can be an important part of caring for your mental health.",
    ASSESSMENT_DEPRESSION_HEADER: "Self Assessment for Depression & Anxiety",
    ASSESSMENT_STRESS_HEADER: "Self Assessment for Stress",
    ASSESSMENT_GERIATRIC_HEADER:"Self Assessment for Senior Adult",
    // APPOINTMENT_HEADER: "Select your preferred time slot and doctor to book appointment.",
    APPOINTMENT_HEADER: "",
    SUBSCRIPTION_HEADER: "Integrative  health plans from HealthEdge",
    HEALTH_INFORMATION_HEADER: "Your medical history will help us provide a personalized holistic multi disciplinary care.",
    MY_ORDERS_HEADER: "Keep track of all your orders here",
    YOUR_RESULTS: "Your Results",
    CARE_PLAN: "Care Plans For You",
    COMPLETED_ASSESSMENT: "Assessment Completed!",
    OVER_THE_LAST_TWO: "Over the last two weeks, how often have you been bothered by any of the following problems?",
    TEST_NAME:"Test Name",
    UPLOADED_BY:"Uploaded by",
    MED_TEST_NAME:"Test Name",
    MED_TEST_UPLOADED_BY:"Uploaded By",
    UPLOAD_BY_ERR_MESSAGE:"Please select uploaded by.",
    MED_TEST_NAME_ERR_MESSAGE:"Please add Test name.",
    CLINICAL_INSTRUCTION:"Clinical Instruction",
    SPEECH_TXT_ERR_MSG: "There seems to be a problem with audio",
    PUBLISH_SELECT:"Confirmation",
    PSYCHOTHERAPY_PSYCHOEDUCATION: "Psychotherapy psychoeducation:",
    CLINICIAN_INSTRUCTION:"Clinician's Instruction",
    CONFIRM_FOLLOW_UP:"Follow up  appointment booked, you cannot modify after saving.",
    COFIRM_NO_FOLLOW_UP:"No Follow up appointment required, you can still modify after saving.",
    SIGN_UP_TITLE: "Let's get your account set up",
    CREACT_ACCOUNT: "Create Account",
    SIGN_UP_TITLE_2:"Choose an option based on who requires care.",
    SIGN_UP_TITLE_3: "To make sure we get this right, we need to verify your email and mobile number.",
    LOG_IN_MAIL_DESC: "Enter mobile number without country code",
    LOG_IN_CCODE_MAIL_DESC:"Please add country code (eg: +91) followed by mobile number",
    CLINICIAN_INSTRUCTION:"Clinician's Instruction",
    ASSESSMENT_HEADER: "Along with your regular reflection, assessing your current risk for common conditions can be an important part of caring for your mental health.",
    ASSESSMENT_RESULT_HEADER: "Self Assessment for Depression & Anxiety",
    // APPOINTMENT_HEADER: "Select your preferred time slot and doctor to book appointment.",
    APPOINTMENT_HEADER: "",
    SUBSCRIPTION_HEADER: "Integrative health plans from HealthEdge",
    HEALTH_INFORMATION_HEADER: "Your medical history will help us provide a personalized holistic multi disciplinary care.",
    MY_ORDERS_HEADER: "Keep track of all your orders here",
    YOUR_RESULTS: "Your Results",
    CARE_PLAN: "Care Plans For You",
    DOCUMENT_UPLOAD: "Document Upload",
    DOCUMENT_UPLOAD_HEADER: "Upload the clinician requested documents",
    OVER_THE_LAST_TWO: "Over the last two weeks, how often have you been bothered by any of the following problems?",
    DEPEDANT: "Dependant(s)",
    FILTER_BY: "Filter by:",
    SELECT_STATUS: "Select Status",
    OPEN: "Open",
    CLOSED: "Closed",
    APPLY_FILTERS: "Apply Filter",
    RESET_FILTERS: "Reset Filter",
    CREATE_COUPOUN:"Create Coupon",
    PLAN_NAME:"Plan Name",
    ADD_INSTRUCTION:"Add Instruction",
    YOUR_SELECTED_PLAN:"Your selected plan",
    EXCLUSIVE_PLAN:"An exclusive plan for you",
    PAYMENT_DETAILS:"Payment Details",
    PAYABLE_AMOUNT:"Payable Amount",
    START_ASSESSMENT:"Let's start your assessment",
    SYMPTOMPS:"These are internationally validated symptom checklists used for detection of stress, depression and anxiety symptoms.",
    LESS_THAN_MINUTES:"It should take less than 2 minutes to complete this assessment.",
    EVERY_15_DAYS:"You can take this assessment every 15 days.",
    NEW_APPOINTMENT: "New Appointment",
    BOOK_SLOT: "Book your slot for New consultation",
    VIDEO_CONSULT:"Video Consultation",
    ARE_U_SURE: "Are you sure to proceed the appointment with ",
    RESCHEDULE_MAIN_CONTENT: "On confirmation, a request to reschedule the appointment will be created. Our Care Admin will reach out to you shortly.",
    RESCHEDULE_SECOND_CONTENT: "Do you want to reschedule?",
    CANCEL_MAIN_CONTENT: "On confirmation, a request to cancel the appointment will be created.",
    CANCEL_SECOND_CONTENT: "Do you want to cancel?",
    SCHEDULE_NEW_APPOINTMENT: "Schedule a new appoinment to show here.",
    NO_UPCOMING_APPOINTMENTS: "No upcoming appoinments!",
    KINDLY:"Kindly",
    LOGIN:"Login",
    OR:"or",
    SIGNUP:"Sign up",
    ASSESSMENT_RESULT:"to know your assessment result.",
    TAKE_NEW_ASSESS:"Take a new assessment to show here.",
    RESCHEDULE: "Reschedule",
    DELETE_ACCOUNT_MESSAGE: "Deleting the account will delete all the profiles under this account.",
    TAKE_EVAL_PLAN:"Take evaluation plan",
    UNLIKELY:"Unlikely",
    MED_LIKELIHOOD:"Medium likelihood",
    HIGH_LIKELIHOOD:"High likelihood",
    FOR_MYSELF: "For Myself",
    FOR_MYSELF_DESCRIPTION: "Create an individual account for you",
    FOR_DEPENDANT: "For Dependent",
    CARE_ADMIN_FOR_DEPENDANT: "Dependent",
    FOR_DEPENDANT_DESCRIPTION: "Create an account for anyone you care",
    IAM_GUARDIAN: "I’m a guardian",
    IAM_CREATING: "I’m creating an account for dependant",
    DISCARD_ASSES_DETAILS:"By continuing, your assessment details will be discarded.",
    OOPS:"Oops!",
    OFFLINE_CONSULT:"Direct Visit Consultation",
    HOSPITAL_VISIT:"Clinic Visit",
    CHOOSE_ROLE:"Choose your role to login",
    LAST_TAKEN_ON:"Last assessment taken on",
    NEXT_ASSESS:"Next assessment can be taken on or after",
    SORRY:"Sorry!!",
    NO_ASSESS_ENABLE:"No Assessment option enabled for your profile",
    BEGIN:"Begin",
    SENIOR_Alt:"Senior Adult",
    DEP_OR_ANX:"Depression/Anxiety",    
    SIGNING_UP: "Signing Up...",
    SIGN_UP_CAPS: "SIGN UP",
    NO_PAST_APPOINTMENT: "No past appointments!",
    COMPLETED_APPOINTMENTS: "Completed appointment will appear here.",
    CLINICIAN_TO_BE_ASSIGNED:"Clinician to be assigned",
    PLUS_ONE_MORE: "+1 more",
    ATTACHMENTS: "Attachment(s)",
    CLICK: "Click Here",
    DASHBOARD_MESSAGE: "Here’s your today’s activity",
    WELCOME: "Welcome",
    DOWNLOAD:"Download",
    NO_ORDERS:"No orders to show!",
    NO_PAYMENT:"You haven't done any payments yet.",
    SCORE_CARD_BOTTOM_TXT: "Your answer indicate you may currently be experiencing symptoms of",
    MINIMAL: "Minimal",
    RELATION_WITH_DEPENDENT: "Relationship with Dependant",
    FIRST_NAME: "First Name",
    SELF_ASSESSMENT_HEADER:"Self Assessment",
    LAST_NAME: "Last Name",
    NEXT_STEP: "Next Step",
    ASSESMENT_SCORE_PAGE_DESCRIPTION : "You may want to pay close attention to how you’re feeling over the next two weeks and retake the questionnaire to see how you are doing. The results of your questionnaire are not a diagnosis of any mental health condition.",
    CARE_ADMIN_VALIDATION_EMAIL_MESSAGE: "Please enter email",
    CARE_ADMIN_VALIDATION_MOBILENUMBER_MESSAGE: "Please enter mobile number",
    CARE_ADMIN_FOR_DEPENDANT_DESCRIPTION: "Create new dependent account",
    CARE_ADMIN_IAM_CREATING:"Creating an account on belhalf of the dependent",
    SEARCH_BY_PATIENT_NEW: "Search by patient",
    NAME_CAPITAL: "NAME",
    ID : "ID",
    SEEN_BY_ME: "Seen by me",
    LAST_cONSULTATION_CAPITAL: "LAST CONSULTATION",
    NEXT_APP_TABLE: "NEXT APPOINTMENT",
    PLAN_DETAILS_CAPITAL: "PLAN",
    AVAILED_ON_NEW: "Availed on",
    EXPIRES_ON: "Expires on",
    EXPIRED_ON: "Expired on",
    CONSULTED_DOCTORS: "Care Team",
    ALL_PATIENTS_SEGMENT: "All Patients",
    MY_PATIENTS_SEGMENT: "My Patients",
    VITALS: "Vitals",
    PATIENTID:"PATIENT ID",
    CONSULTED_CLINICIAN: "Consulted clinicians for ",
    LAST_CONSULTED_ON: "Last consulted on",
}